import {register} from 'swiper/element/bundle';

/**
 * Initialize a single Swiper element with its parameters
 * @param {HTMLElement} swiperEl - The swiper container element
 */
const initSingleSwiper = (swiperEl) => {
  try {
    const dataParams = swiperEl.getAttribute("data-init-params");
    const swiperParams = JSON.parse(dataParams);

    if (swiperEl.initialized) {
      swiperEl.initialized = false;
    }

    Object.assign(swiperEl, swiperParams);
    swiperEl.initialize();
  } catch (error) {
    console.error("Error initializing swiper:", error);
  }
};

/**
 * Initialize new swipers that haven't been initialized yet
 */
const initSwipers = () => {
  const preInitSwipers = document.querySelectorAll(
    "swiper-container[init='false']"
  );

  if (!preInitSwipers.length) return;
  preInitSwipers.forEach(initSingleSwiper);
};

/**
 * Update all swipers that have the init attribute
 */
const updateSwipers = () => {
  const swipers = document.querySelectorAll("swiper-container[init]");
  swipers.forEach(initSingleSwiper);
  afterSwiperInit();
};
/**
 * Additionals after '<swiper-container>' custom element is defined
 */
const afterSwiperInit = () => {
  customElements.whenDefined('swiper-container').then(() => {
    document.querySelectorAll('swiper-container').forEach((el) => el.classList.add('is-initialized'));
  });

  const anouncementSliderEl = document.querySelector('.announcement__swiper-container');
  anouncementSliderEl.swiper.on('slideChange', function (e) {
    document.documentElement.style.setProperty('--announcement-bar-height', `${document.querySelector('[data-announcement-bar-height]').offsetHeight}px`);
    setTimeout(() => {
      const headerBottom = document.querySelector('[data-header-height]').getBoundingClientRect().bottom;
      document.documentElement.style.setProperty('--header-bottom', `${headerBottom}px`);
    }, 500)
  });


};

/**
 * Initialize Swiper on a page load
 */
window.addEventListener("load", () => {
  register();
  initSwipers();
  afterSwiperInit();
});

/**
 * Handle Shopify section changes
 */

if (Shopify.designMode) {
  const shopifyEvents = ["shopify:section:load", "shopify:section:reorder"];
  shopifyEvents.forEach(eventName => {
    console.log(eventName, "eventName")
    document.addEventListener(eventName, updateSwipers);
  });
}
